
class Paginator
{
    constructor( data, page = 1, each = Paginator.each )
    {
        this.data = data;
        this.page = + page;
        this.each = + each;
    }


    get pages()
    {
        return Math.ceil( this.data.length / this.each );
    }

    get length()
    {
        return this.data.length;
    }


    get results()
    {
        const start = ( this.page - 1 ) * this.each;

        return this.data.slice( start, start + this.each );
    }


    get next()
    {
        return this.page + 1;
    }


    get previous()
    {
        return this.page - 1;
    }

}
Paginator.each = 15;

export default Paginator;
